import { memo } from "react";

import variables from "../../styles/_variables.module.scss";

const ActionArrowRight = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4866_2317)">
      <path d="M10.5 6H1.5" stroke="currentColor" strokeWidth="0.827586" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.5 3L10.5 6L7.5 9"
        stroke={variables["foreground"]}
        strokeWidth="0.827586"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4866_2317">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(ActionArrowRight);
